// src/api/queryPageApi.js

import axios from "axios";

/**
 * Create an axios instance with a default baseURL.
 * You can change the baseURL if your back-end runs on a different host/port.
 */
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || "http://localhost:5000",
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * Interceptors for handling errors (401, 403, etc.).
 * If we get a 401 or 403, we log it. 
 * Optionally, you might want to dispatch a logout or redirect to login.
 */
axiosInstance.interceptors.response.use(
  (response) => response, // pass through if successful
  (error) => {
    if (error.response) {
      const { status } = error.response;
      if (status === 401 || status === 403) {
        console.error("Unauthorized or forbidden:", status);
        // Here you could do:
        // - sign user out
        // - redirect to /login
        // - show a modal, etc.
      }
    }
    return Promise.reject(error);
  }
);

/**
 * fetchSingleQuery
 * @param {string} token      - Firebase ID token for authorization
 * @param {string} queryType  - "name" | "email" | "promoCode"
 * @param {string} queryValue - The actual value for that field
 * @returns {Promise<Array>}  - The array of results returned by the back-end
 */
export const fetchSingleQuery = async (token, queryParams) => {
  const resp = await axiosInstance.post("/user/api/singlequery", queryParams, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return resp.data;
};

/**
 * fetchMultipleQuery
 * @param {string} token       - Firebase ID token for authorization
 * @param {object} queryParams - { statusQuery, mediaQuery, dateFromQuery, dateToQuery, taskType, ... }
 * @returns {Promise<Array>}   - The array of results returned by the back-end
 */
export const fetchMultipleQuery = async (token, queryParams) => {
  const resp = await axiosInstance.post("/user/api/multiplequery", queryParams, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return resp.data;
};
